import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { useAuth } from "../../Context/AuthContext";
import {
  Box,
  Button,
  TextField,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import Interactionmodal from "./Interactionmodal";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const Interactionslist = () => {
  const roleId = sessionStorage.getItem("roleId");
  const { token } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [allinteractions, setAllinteractions] = useState([]);
  const [locationTypes, setlocationTypes] = useState([]);
  const [statustypes, setStatustypes] = useState([]);
  const [leadstatustypes, setleadstatustypes] = useState([]);
  const [annualincometypes, setannualincometypes] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (rowData) => {
    setSelectedData(rowData);
    console.log(selectedData, "selectedData2");
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedData(null);
    setOpenModal(false);
  };

  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const formatDateStringhours = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return `${date.toLocaleDateString("en-GB")} ${date.toLocaleTimeString(
        "en-GB",
        { hour: "2-digit", minute: "2-digit" }
      )}`;
    } else {
      return "N/A";
    }
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {});
      console.log("locationdata", response);
      setlocationTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getLeadstatusData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setleadstatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getAnnualincomeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setannualincometypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    // getEngagementtypeData();
    getLocationtypeData();
    getstatustypeData();
    getLeadstatusData();
    getAnnualincomeData();
  }, []);

  const Columns = [
    // { field: "clientName", headerName: "Name", width: 150 },
    {
      field: "clientName",
      headerName: "Name",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          <div
            title={`${params.value}`}
            onClick={() => handleOpenModal(params.row)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "140px",
            }}
          >
            {params.value}
          </div>
        </div>
      ),
    },
    {
      field: "userName",
      headerName: "Wealth Advisor",
      width: 150,
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    // {
    //   field: 'meeting_at',
    //   headerName: 'Meeting Date',
    //   width: 150,
    //   renderCell: (params) => (
    //     <div>
    //       <div
    //         onClick={() => handleOpenModal(params.row)}
    //         style={{ color:"blue", textDecoration:"underline", cursor: 'pointer' }}
    //       >
    //         {formatDateString(params.value)}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "meeting_at",
      headerName: "Meeting Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "location_type",
      headerName: "Location Type",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {locationTypes.find((item) => item.id === params.value)
            ?.masterValueDesc || "-"}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {
            statustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "lead_status",
      headerName: "Lead Status",
      width: 170,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {leadstatustypes.find((item) => item.id === params.value)
            ?.masterValueDesc || "-"}
        </div>
      ),
    },

    {
      field: "expected_date_of_closure",
      headerName: "Exp.Dt.Closure",
      valueFormatter: (params) => formatDateString(params.value),
      width: 170,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "estimated_annual_income",
      headerName: "Est.Annual Income",
      width: 170,
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {
            annualincometypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "followup_date_n_time",
      headerName: "Follow Up Date",
      valueFormatter: (params) => formatDateString(params.value),
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    //  {
    //   field: 'action',
    //   headerName: 'Action',
    //   width: 100,
    //   renderCell: (params) => (
    //     <DeleteIcon
    //       style={{ cursor: 'pointer' }}
    //       onClick={() => handleDeleteClickdelete(params.row.id)}
    //     />
    //   ),
    // },
  ];
  const fetchInteractions = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/fetchReferralInteraction`,
        { userId: "all" },
        { headers }
      );
      console.log("respo", response);
      setAllinteractions(response?.data.response || []);
    } catch (error) {
      console.error("Error fetching graph data:", error.message);
    }
    setLoading(false);
  };
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredInteractions = allinteractions.filter((interaction) => {
    const { clientName, lead_status_desc, userName } = interaction;
    return (
      (clientName?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
      (lead_status_desc?.toLowerCase() || "").includes(
        searchQuery.toLowerCase()
      ) ||
      (userName?.toLowerCase() || "").includes(searchQuery.toLowerCase())
    );
  });

  useEffect(() => {
    fetchInteractions();
  }, []);
  console.log("respo2", allinteractions);
  console.log("load", loading);
  const handleDownloadCSV = () => {
    const csvData = filteredInteractions.map((row) => ({
      Name: row.clientName || "-",
      "Wealth Advisor": row.userName || "-",
      "Meeting Date": row.meeting_at ? formatDateString(row.meeting_at) : "-",
      "Location Type":
        locationTypes.find((item) => item.id === row.location_type)
          ?.masterValueDesc || "-",
      Status:
        statustypes.find((item) => item.id === row.status)?.masterValueDesc ||
        "-",
      "Lead Status":
        leadstatustypes.find((item) => item.id === row.lead_status)
          ?.masterValueDesc || "-",
      "Exp.Dt.Closure": row.expected_date_of_closure
        ? formatDateString(row.expected_date_of_closure)
        : "-",
      "Est.Annual Income":
        annualincometypes.find(
          (item) => item.id === row.estimated_annual_income
        )?.masterValueDesc || "-",
      "Follow Up Date": row.followup_date_n_time
        ? formatDateString(row.followup_date_n_time)
        : "-",
    }));

    return csvData;
  };

  return (
    <>
      {/* <Typography>Interactionslist</Typography> */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // height: "50%",
            marginTop: "250px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={styles.main_container}>
          <Paper sx={styles.dashboard_paper}>
            <h3>Interactions</h3>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                p: 1,
                justifyContent: "flex-end",
                width: "50%",
                marginLeft: "auto",
              }}
            >
              <Button
                sx={styles.btnback}
                variant="contained"
                onClick={() => navigate("/employeedashboard")}
              >
                Back
              </Button>
            </Box>
          </Paper>
          <Box
            sx={{
              width: "100%",
              height: "88vh",
              background: "#f2f2f2",
            }}
          >
            <Paper
              elevation={3}
              sx={{
                margin: "10px 20px 20px 20px",
                height: "590px",
                borderRadius: "10px",
              }}
            >
              <Box sx={{ textAlign: "left" }}>
                {/* ----------------------------Filter--------------------------------------- */}
                <Box
                  sx={{
                    textAlign: "left",
                    position: "relative",
                    margin: "5px 0px",
                  }}
                >
                  <Tooltip
                    title="Search by Client Name / Lead Status / Wealth Advisor"
                    arrow
                  >
                    <input
                      style={{
                        width: "200px",
                        height: "30px",
                        fontSize: "11px",
                        borderRadius: "8px",
                        paddingLeft: "35px",
                        margin: "12px", // Adjust padding to make space for the icon
                      }}
                      type="text"
                      placeholder="Search by Client Name / Lead Status / Wealth Advisor"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    <SearchIcon
                      sx={{
                        position: "absolute",
                        left: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "grey",
                      }}
                    />
                  </Tooltip>
                  {(roleId === "1" || roleId === "6" || roleId === "7") && (
                    <CSVLink
                      data={handleDownloadCSV()}
                      filename="interactions.csv"
                      style={{ textDecoration: "none" }}
                    >
                      <Button sx={styles.btn} variant="contained">
                        Download CSV
                      </Button>
                    </CSVLink>
                  )}
                </Box>
                {/* ---------------------------------------------------------------------- */}
              </Box>
              <div style={{ height: 524, width: "100%", overflow: "auto" }}>
                <DataGrid
                  loading={loading}
                  rows={filteredInteractions}
                  columns={Columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 20]}
                  // sx={sxStyles.boldHeader}
                  sx={{
                    ...sxStyles.boldHeader, // Spread existing styles
                    fontSize: "13px",
                    "& .MuiDataGrid-columnHeaders": {
                      fontWeight: "bold",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-cell": {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                  }}
                />
              </div>
            </Paper>
          </Box>
        </Box>
      )}
      <Interactionmodal
        open={openModal}
        onClose={handleCloseModal}
        selectedData={selectedData}
        onStatusUpdate={(status) => {
          console.log("Status updated:", status);
        }}
      />
    </>
  );
};

export default Interactionslist;

const styles = {
  btn: {
    width: "140px",
    fontSize: "11px",
    margin: "10px 11px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
    // border:"1px solid green",
  },
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
    // border:"1px solid red",
  },
  btnback: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
